<template>
  <v-container :style="{ maxWidth: '1200px'}" class="mb-10">
    <!-- <h3 class="text-right">
      <v-btn
                color="#205295"
                dark
                class="mb-2 rounded-pill"
              >
              {{ lg_listroom1.create_new_meeting }}
                 <v-icon
        right
        dark
      >
        mdi-plus
      </v-icon>
              </v-btn>
    </h3> -->
    <!-- <v-icon color="red">mdi-shield-account</v-icon>
      {{ lg_listroom1.title_remark }} -->
                 <v-row
          class="mt-4"
      justify="space-between"
    >
      <v-col
      cols="12"
        md="4"
      >
      <!-- class="rounded-pill" -->
      <v-text-field
      class=""
            v-model="search"
            clearable
            solo
            outlined
            dense
            prepend-inner-icon="mdi-magnify"
            hide-details
            :label="lg_listroom1.room_search"
          ></v-text-field>
      </v-col>
      <v-col
      class="text-right"
      cols="12"
        md="4"
      >
      <v-btn
      :height="$vuetify.breakpoint.xsOnly?35:null"
                color="#205295"
                dark
                class="mb-2"
                @click="Clickdialogcreate()"
              >
              {{ lg_listroom1.create_new_meeting }}
                 <v-icon
        right
        dark
      >
        mdi-plus
      </v-icon>
              </v-btn>
      </v-col>  
    
    </v-row>
    <v-row
     v-if="mDataArray.length == 0"
       class="mt-4"
      justify="center"
       align="center"
    >
      <v-col
      cols="12"
        md="12"
        justify="center"
        align="center"
      >
      <h2 style="color:#205295 !important;"> {{ lg_listroom1.no_meeting_room }}</h2>

      </v-col>   
     </v-row>

    <v-data-iterator
      v-else
      :items="mDataArray"
      :items-per-page.sync="itemsPerPage"
      :page.sync="page"
      :search="search"
      :sort-by="sortBy.toLowerCase()"
      :sort-desc="sortDesc"
      hide-default-footer
    >
    <!--  flat
            solo-inverted 
            prepend-inner-icon="mdi-magnify"-->
      <!-- <template v-slot:header>
      </template> -->

      <template v-slot:default="props">
         <v-simple-table style="border: 1px solid #e0e0e0; border-radius: 8px; overflow: hidden; overflow-y: auto; overflow-x: hidden;" class="mt-8">
          <tbody>
        <tr
          v-for="item in props.items"
          :key="item.meet_name"
          style="border-bottom: 1px solid #eeeeee; vertical-align: top;min-height: 210px;height: 210px;"
        >
          <!-- style="border:2px solid #d0d0d0;box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12) !important;" -->
            <td>
               <v-row
               class="mt-1"
      justify="space-between"
    >
     <v-col
      cols="12"
        md="4"
      ></v-col>
                <v-col
      :class="$vuetify.breakpoint.xsOnly?'text-left mt-4':$vuetify.breakpoint.smOnly?'text-right mt-n6':'text-right'"
      class="ma-0"
        justify="end"
      cols="12"
        md="4"
      >
      <h3 class="font-weight-medium">
      <v-menu
            bottom
            right
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
               :style=" $vuetify.breakpoint.xsOnly 
              ? { float: 'right', marginRight: '20px', marginTop: '-50px' } 
              : {} "
              color="black"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon v-if="$vuetify.breakpoint.xsOnly">mdi-dots-horizontal</v-icon>
                <v-icon v-else>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
              link
               @click="moreinfodialogfn(item)"
              >
                <v-list-item-title >
          {{ lg_listroom1.more_info }}
                  </v-list-item-title>
              </v-list-item>

              <v-list-item
              link
               @click="dialogCloseMeetion(item)"
                style="color:red;"
              >
                <v-list-item-title color="#FF5733">{{ lg_listroom1.delete_this_meeting }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
            </h3>
      </v-col>
               </v-row>

                <v-row
      justify="space-between"
      class="mt-n12"
      :class="{'margin-bottom-in-card': $vuetify.breakpoint.mdAndUp }"
    >
      <v-col
      cols="12"
        md="4"
      >
      <!-- <v-card-title class="subheading font-weight-bold"> -->
       <h2 class="ml-4">{{ item.meet_topic }}</h2> 
       <p class="section-desc ml-4 ma-0"> {{ lg_listroom1.room_id }} {{ item.meet_name }}</p> 
        <v-list-item
        class="mb-n8"
                  :style="{
                    visibility:
                      item.meet_pass === null || item.meet_pass === ''
                        ? 'hidden'
                        : 'visible',
                  }"
                >
                  <v-list-item-content style="max-width: 60px">{{
                    lg_listroom1.room_remark
                  }}</v-list-item-content>
                  <v-list-item-content
                    :style="{
                      visibility:
                        item.meet_pass === null || item.meet_pass === ''
                          ? 'hidden'
                          : 'visible',
                    }"
                  >
                    <v-list-item-content class="align-end red--text" style="font-size:12px;">{{
                      lg_listroom1.room_message_pass
                    }}</v-list-item-content>
                  </v-list-item-content>
                </v-list-item>

                 <v-list-item
                  class="mb-n8"
                :class="{ 'd-none': item.meet_verify_sta === null || item.meet_verify_sta === 'N' }"
                >
                  <v-list-item-content style="max-width: 60px;">{{
                    lg_listroom1.room_remark
                  }}</v-list-item-content>
                  
                    <v-list-item-content class="align-end red--text" style="font-size:12px;">{{
                      lg_listroom1.enter_sub_email
                    }}</v-list-item-content>
                </v-list-item>

                 <v-list-item
                  class="mb-n8"
                 :class="{ 'd-none': item.meet_verify_login === null || item.meet_verify_login === 'N' }"
                >
                  <v-list-item-content style="max-width: 60px;">{{
                    lg_listroom1.room_remark
                  }}</v-list-item-content>

                    <v-list-item-content class="align-end red--text" style="font-size:12px;">{{
                      lg_listroom1.require_sub_login2
                    }}</v-list-item-content>
                </v-list-item>

                    <v-list-item
                  class="mt-2"
                 :class="{ 'd-none': item.meet_record_on_start_sta === null || item.meet_record_on_start_sta === 'N' }"
                >
                  <v-list-item-content style="max-width: 60px;">{{
                    lg_listroom1.room_remark
                  }}</v-list-item-content>

                    <v-list-item-content class="align-end red--text" style="font-size:12px;">{{
                      lg_listroom1.room_record_detail
                    }}</v-list-item-content>
                </v-list-item>
    <!-- </v-card-title> -->
      </v-col>
           <v-col
      cols="12"
        md="3"
      >
       <p class="section-desc ml-4 my-0"> {{lg_listroom1.room_date}} :</p> 
      <p class="section-desc ml-4 my-0" >  {{ formatDate(item.meet_create) }} GMT+7</p>

      <p class="section-desc ml-4 my-0"> {{lg_listroom1.room_schedule}} :</p> 
      <p class="section-desc ml-4 my-0" style="color:#205295 !important;">  {{ formatDate(item.meet_start) }} GMT+7</p> 
  
 <v-list-item
                :class="{ 'd-none': item.meet_pass === null || item.meet_pass === '' }"
                class="mt-n4"
                
                >
                  <v-list-item-content style="max-width: 110px;font-size:16px;">{{
                    lg_listroom1.password
                  }}</v-list-item-content>
                  <v-list-item-content
                  >
                    <v-list-item-content class="align-end red--text" style="font-size:16px;">
                      <!-- {{
                      item.meet_pass
                    }} -->
                      <v-text-field
                        class="align-end red--text ml-n1"
                        single-line
                        readonly
                        flat 
                        hide-details
                        v-model="item.meet_pass"
                        :append-icon="
                          item.showpass ? 'visibility' : 'visibility_off'
                        "
                        @click:append="item.showpass = !item.showpass"
                        :type="item.showpass ? 'password' : 'text'"
                        required
                        variant
                        solo
                        dense
                      />
                    </v-list-item-content>
                  </v-list-item-content>
                </v-list-item>

      </v-col>
      <v-col
      :class="$vuetify.breakpoint.xsOnly?'text-left mt-n2':'text-right'"
       class="text-center d-flex flex-column"
        cols="12"
        md="5"
        sm="12"
        sx="12"
      >
      <v-row>
        <v-col 
           class="pa-0"
           :class="!$vuetify.breakpoint.mdAndUp?'text-center':'text-right pr-12'"
        cols="12">
      <h3 class="font-weight-medium">
      <!-- {{ lg_listroom1.room_id }} {{ item.meet_name }} -->
        
         <v-btn
         :class="{ 'widthbtnjoinmobile200': $vuetify.breakpoint.xsOnly,'widthbtnjoinipad200': $vuetify.breakpoint.smOnly}"
        :large="$vuetify.breakpoint.xsOnly"
        @click="assignMessage(item)"
       text
        color="#215295"
        class="mb-5 ml-5 mr-5 get-started-link text-decoration-underline"
            v-clipboard:copy="message"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
  
          >
            {{ lg_listroom1.dialog_invite_copy_link }}
       
        </v-btn>
   
      <!-- <v-menu
            bottom
            right
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
               :style=" $vuetify.breakpoint.xsOnly 
              ? { float: 'right', marginRight: '20px', marginTop: '-50px' } 
              : {} "
              color="black"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon v-if="$vuetify.breakpoint.xsOnly">mdi-dots-horizontal</v-icon>
                <v-icon v-else>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
              link
               @click="moreinfodialogfn(item)"
              >
                <v-list-item-title >
          {{ lg_listroom1.more_info }}
                  </v-list-item-title>
              </v-list-item>

              <v-list-item
              link
               @click="dialogCloseMeetion(item)"
                style="color:red;"
              >
                <v-list-item-title color="#FF5733">{{ lg_listroom1.delete_this_meeting }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu> -->
            </h3>
            </v-col>
            </v-row>

            <!-- btn invite and join -->
 <v-row class="d-flex justify-end" justify="end" align="end">
    <v-col class="text-center" cols="12" md="6" sm="12" sx="12" >
      <div class="d-flex flex-column">
        <v-btn
          :class="{ 'widthbtnjoinmobile200': $vuetify.breakpoint.xsOnly, 'widthbtnjoinipad200': $vuetify.breakpoint.smOnly }"
          :large="$vuetify.breakpoint.xsOnly"
          color="#205295"
          outlined
          class="mb-5 ml-2 mr-2 darken text-tranform-none"
          @click="openInviteModal(item)"
        >
          {{ lg_listroom1.btn_invite }}
        </v-btn>
      </div>
    </v-col>
    <v-col class="text-center" justify="center" cols="12" md="6" sm="12" sx="12">
      <div class="d-flex flex-column" v-if="checkRoleAdmin">
        <v-btn
          :class="{ 'widthbtnjoinmobile200': $vuetify.breakpoint.xsOnly, 'widthbtnjoinipad200': $vuetify.breakpoint.smOnly }"
          :large="$vuetify.breakpoint.xsOnly"
          color="#205295"
          class="mb-5 ml-2 mr-2 darken white--text text-tranform-none"
          @click="onClickJoinMeetion(item)"
        >
          {{ lg_listroom1.btn_join }}
          <v-icon right dark>mdi-chevron-right</v-icon>
        </v-btn>
      </div>
      <div class="d-flex flex-column" v-if="!checkRoleAdmin">
        <v-btn
          :class="{ 'widthbtnjoinmobile200': $vuetify.breakpoint.xsOnly, 'widthbtnjoinipad200': $vuetify.breakpoint.smOnly }"
          :large="$vuetify.breakpoint.xsOnly"
          color="#205295"
          class="mb-5 ml-2 mr-2 darken white--text text-tranform-none"
          @click="onClickJoinMeetion(item)"
        >
          {{ lg_listroom1.btn_join }}
          <v-icon right dark>mdi-chevron-right</v-icon>
        </v-btn>
      </div>
    </v-col>
  </v-row>
      </v-col>


    </v-row>
            

              <!-- <v-divider v-if="!$vuetify.breakpoint.xsOnly"></v-divider> -->
              <!-- <v-row :class="$vuetify.breakpoint.xsOnly?'mt-n6':'margin-top-btn-card'" justify="end"> -->
                    <!-- <v-col
      cols="12"
        md="5"
      >
              <v-list dense>
                <v-list-item class="mt-n2" style="color:#205295 !important;" >
                  <v-list-item-content style="max-width: 100px;" >{{
                    lg_listroom1.room_schedule
                  }}</v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{ formatDate(item.meet_start) }}
                  </v-list-item-content>
                </v-list-item>

                <v-list-item class="mt-n2">
                  <v-list-item-content style="max-width: 100px">{{
                    lg_listroom1.room_date
                  }}</v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{ formatDate(item.meet_create) }}
                  </v-list-item-content>
                </v-list-item>


                <v-list-item
                  :style="{
                    visibility:
                      item.meet_pass === null || item.meet_pass === ''
                        ? 'hidden'
                        : 'visible',
                  }"
                >
                  <v-list-item-content style="max-width: 100px">{{
                    lg_listroom1.room_remark
                  }}</v-list-item-content>
                  <v-list-item-content
                    :style="{
                      visibility:
                        item.meet_pass === null || item.meet_pass === ''
                          ? 'hidden'
                          : 'visible',
                    }"
                  >
                    <v-list-item-content class="align-end red--text">{{
                      lg_listroom1.room_message_pass
                    }}</v-list-item-content>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                class="mt-n2"
                  :style="{
                    display:
                      item.meet_verify_login === null || item.meet_verify_login === 'N'
                        ? 'none'
                        : 'show',
                  }"
                >
                  <v-list-item-content style="max-width: 100px">{{
                    lg_listroom1.room_remark
                  }}</v-list-item-content>
                  <v-list-item-content
                    :style="{
                      display:
                        item.meet_verify_login === null || item.meet_verify_login === 'N'
                          ? 'none'
                          : 'show',
                    }"
                  >
                    <v-list-item-content class="align-end red--text">{{
                      lg_listroom1.require_sub_login2
                    }}</v-list-item-content>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                class="mt-n2"
                  :style="{
                    display:
                      item.meet_verify_sta === null || item.meet_verify_sta === 'N'
                        ? 'none'
                        : 'show',
                  }"
                >
                  <v-list-item-content style="max-width: 100px">{{
                    lg_listroom1.room_remark
                  }}</v-list-item-content>
                  <v-list-item-content
                    :style="{
                      display:
                        item.meet_verify_sta === null || item.meet_verify_sta === 'N'
                          ? 'none'
                          : 'show',
                    }"
                  >
                    <v-list-item-content class="align-end red--text">{{
                      lg_listroom1.enter_sub_email
                    }}</v-list-item-content>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                class="mt-n2"
                  :style="{
                    display:
                      item.meet_verify_sta === null || item.meet_record_on_start_sta === 'N'
                        ? 'none'
                        : 'show',
                  }"
                >
                  <v-list-item-content style="max-width: 100px">{{
                    lg_listroom1.room_record
                  }}</v-list-item-content>
                  <v-list-item-content
                    :style="{
                      display:
                        item.meet_verify_sta === null || item.meet_record_on_start_sta === 'N'
                          ? 'none'
                          : 'show',
                    }"
                  >
                    <v-list-item-content class="align-end red--text">{{
                      lg_listroom1.room_record_detail
                    }}</v-list-item-content>
                  </v-list-item-content>
                </v-list-item>


                <v-list-item
                class="mt-n2"
                  :style="{
                    display:
                      item.meet_lobby_sta === 'N' ? 'none' : 'show',
                  }"
                >
                  <v-list-item-content style="max-width: 100px">{{
                    lg_listroom1.room_lobby
                  }}</v-list-item-content>
                  <v-list-item-content
                    :style="{
                      display:
                        item.meet_lobby_sta === 'N' ? 'none' : 'show',
                    }"
                  >
                    <v-list-item-content class="align-end red--text">{{
                      lg_listroom1.meet_sub__option_lobby
                    }}</v-list-item-content>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col> -->
              <!-- <div class="d-flex flex-column">
                <v-btn
                  v-if="checkRoleAdmin"
                  class="mb-5 ml-5 mr-5 blue-grey lighten-5"
                  @click="doCopy('Admin', item)"
                >
                  Copy Invite Moderator Link
                </v-btn>
              </div> -->

              <!-- <v-col
              class="d-flex align-end"
      cols="12"
        md="7"
      >
              <v-row
      justify="end"
      class="mt-2"
    >
    
      <v-col
      class="text-center"
        cols="12"
        md="4"
        sm="12"
        sx="12"
      > -->
      <!-- class="mb-5 ml-5 mr-5 blue darken-3 white--text" -->
      <!-- <div class="d-flex flex-column" > -->
        <!-- :large="$vuetify.breakpoint.xsOnly" -->
      <!-- <v-btn
      :class="{ 'widthbtnjoinmobile200': $vuetify.breakpoint.xsOnly,'widthbtnjoinipad200': $vuetify.breakpoint.smOnly}"
        :large="$vuetify.breakpoint.xsOnly"
       color="#205295"
       outlined
                  class="mb-5 ml-2 mr-2 darken text-tranform-none"
                  @click="openInviteModal(item)"
                >
                  {{ lg_listroom1.btn_invite }}
                </v-btn>
              </div>
      </v-col> -->
         <!-- style="justify-items: center;" -->
      <!-- <v-col
        class="text-center"
        justify="center"
        cols="12"
        md="4"
        sm="12"
        sx="12"
      >
      <div class="d-flex flex-column" v-if="checkRoleAdmin" >
                <v-btn
                 :class="{ 'widthbtnjoinmobile200': $vuetify.breakpoint.xsOnly,'widthbtnjoinipad200': $vuetify.breakpoint.smOnly}"
                 :large="$vuetify.breakpoint.xsOnly"
                color="#205295"
                  class="mb-5 ml-2 mr-2 darken white--text text-tranform-none"
                  @click="onClickJoinMeetion(item)"
                >
                  {{ lg_listroom1.btn_join }}
                  <v-icon
        right
        dark
      >
      mdi-chevron-right
      </v-icon>
                </v-btn>
              </div>
      <div class="d-flex flex-column" v-if="!checkRoleAdmin">
                <v-btn
                 :class="{ 'widthbtnjoinmobile200': $vuetify.breakpoint.xsOnly,'widthbtnjoinipad200': $vuetify.breakpoint.smOnly}"
                :large="$vuetify.breakpoint.xsOnly"
                 color="#205295"
                  class="mb-5 ml-2 mr-2 darken white--text text-tranform-none"
                  @click="onClickJoinMeetion(item)"
                >
                  {{ lg_listroom1.btn_join }}
                  <v-icon
        right
        dark
      >
      mdi-chevron-right
      </v-icon>
                </v-btn>
              </div>
      </v-col>
    </v-row>
  </v-col>
  </v-row> -->
              <!-- <div class="d-flex flex-column">
                <v-btn
                  class="mb-5 ml-5 mr-5 blue darken-3 white--text"
                  @click="openInviteModal(item)"
                >
                  {{ lg_listroom1.btn_invite }}
                </v-btn>
              </div> -->

              <!-- @click="onClickJoinMeetion(item)" -->
              <!-- :href="item.meet_admin_link" -->
              <!-- <div class="d-flex flex-column" v-if="checkRoleAdmin">
                <v-btn
                  class="mb-5 ml-5 mr-5 green darken white--text text-tranform-none"
                  @click="onClickJoinMeetion(item)"
                >
                  {{ lg_listroom1.btn_join }}
                </v-btn>
              </div>
              <div class="d-flex flex-column" v-if="!checkRoleAdmin">
                <v-btn
                  class="mb-5 ml-5 mr-5 green darken white--text text-tranform-none"
                  @click="onClickJoinMeetion(item)"
                >
                  {{ lg_listroom1.btn_join }}
                </v-btn>
              </div> -->
              <!-- <div class="d-flex flex-column" v-if="acc_plan === 'PREMIUM'">
                <v-btn
                  class="mb-5 ml-5 mr-5 orange darken white--text text-tranform-none"
                  @click="onClickJoinLivestream(item)"
                >
                  {{ lg_listroom1.btn_join_livestream }}
                </v-btn>
              </div> -->
              <!-- <div class="d-flex flex-column">
                <v-btn
                  class="mb-5 ml-5 mr-5 grey darken-4 white--text"
                  @click="dialogCloseMeetion(item)"
                >
                  {{ lg_listroom1.btn_close }}
                </v-btn>
              </div> -->
            </td>
          </tr>
      </tbody>
         </v-simple-table>
      </template>

      <!-- <template v-slot:footer>
        <v-row
          class="justify-space-between px-3 pt-5 pb-5"
          align="center"
          justify="center"
        >
          <v-spacer></v-spacer>
        </v-row>

        <v-layout class="justify-space-between mb-0 mt-5">
          <div>
            <span class="grey--text">Items per page</span>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  dark
                  text
                  color="primary"
                  class="ml-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ itemsPerPage }}
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(number, index) in itemsPerPageArray"
                  :key="index"
                  @click="updateItemsPerPage(number)"
                >
                  <v-list-item-title>{{ number }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <div>
            <span class="mr-4 grey--text">
              Page {{ page }} of {{ numberOfPages }}
            </span>
            <v-btn
              outlined
              plain
              small
              color="blue darken-3"
              class="mr-1"
              @click="formerPage"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn
              outlined
              plain
              small
              color="blue darken-3"
              class="ml-1"
              @click="nextPage"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </v-layout>
      </template> -->
       <template v-slot:footer>
    <v-layout class="justify-space-between align-center mt-4 mb-2 px-2">
      <!-- <div class="d-flex align-center">
        <span class="grey--text" style="font-size:13px;">Items per page</span>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn dark text color="primary" class="ml-2" v-bind="attrs" v-on="on">
              {{ itemsPerPage }}
              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(number, index) in itemsPerPageArray"
              :key="index"
              @click="updateItemsPerPage(number)"
            >
              <v-list-item-title>{{ number }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div> -->

      <div class="d-flex align-center" style="gap: 4px;">
        <!-- border: 1px solid #e0e0e0; -->
  <v-btn
    icon small
    style="border-radius: 6px;"
    @click="formerPage"
  >
    <v-icon small color="black">mdi-chevron-left</v-icon>
  </v-btn>

  <v-btn
    v-for="n in numberOfPages"
    :key="n"
    icon small
    :style="page === n
      ? 'background:#e8eaf6; border-radius:6px; color:#1a56db;'
      : 'border-radius:6px; color:#000000;'"
    style="min-width: 32px;"
    @click="page = n"
  >
    <span style="font-size: 13px;">{{ n }}</span>
  </v-btn>

  <v-btn
    icon small
    style="border-radius: 6px;"
    @click="nextPage"
  >
    <v-icon small color="black">mdi-chevron-right</v-icon>
  </v-btn>
</div>
    </v-layout>
  </template>
    </v-data-iterator>

    <LoadingDialog></LoadingDialog>

    <!-- Alert Dialog -->
    <v-dialog v-model="alertDlg" max-width="60%">
      <v-card>
        <v-card-title class="headline">{{
          this.titleMessageAlert
        }}</v-card-title>

        <v-card-text class="body">
          {{ this.messageAlert }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            text
            @click="alertDlg = false"
            col="12"
            lg="12"
            md="12"
            sm="12"
          >
            Close
          </v-btn>

          <!-- <v-btn outlined color="error" text @click="confirmDelete">
            Confirm
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Alert Dialog -->
    <v-dialog v-model="dialog" scrollable width="unset">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false" height="20">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-4" align="center">

          <h3
            v-bind:style="{
              color: '#000000',
            }"
          >
            {{ this.lg_listroom1.dialog_invite_title }}
          </h3>
          <v-combobox
           class="mt-5"
            v-model="emails"
            outlined
            clearable
            :label="lg_listroom1.dialog_invite_send_to"
            multiple
            prepend-icon="mdi-email"
          >
            <template v-slot:selection="{ attrs, item, select, selected }">
              <v-chip
                v-bind="attrs"
                :input-value="selected"
                close
                @click:close="removeEmail(item)"
              >
                <strong>{{ item }}</strong
                >&nbsp;
              </v-chip>
            </template>
          </v-combobox>

          <v-btn
            align="center"
            min-width="170"
            color="#3E73BB"
            class="rounded-pill"
            dark
            @click="inviteMembers(item)"
          >
            {{ this.lg_listroom1.btn_send }}
          </v-btn>

          <!-- <h3
           class="mt-5"
            v-clipboard:copy="message"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
            align="center"
            v-bind:style="{
              color: '#000000',
              align: 'left',
              textDecoration: 'underline',
              cursor: 'pointer',
            }"
          >
            {{ this.lg_listroom1.dialog_invite_copy_link }}
          </h3> -->

          <!-- <h3
           class="mt-5 mb-2"
            v-clipboard:copy="messagelivestream"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
            align="center"
            v-bind:style="{
              color: '#000000',
              align: 'left',
              textDecoration: 'underline',
              cursor: 'pointer',
            }"
            @click="onClickMenu('/contact')"
          >
            {{ this.lg_listroom1.dialog_invite_copy_link_livestream }}
          </h3> -->
        </v-card-text>
        <!-- <v-divider></v-divider> -->
        <!-- <v-card-actions>
          <v-btn
            class="mx-1"
            text
            color="blue darken-1"
            v-clipboard:copy="message"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            <v-icon dark right> mdi-content-copy </v-icon>
            {{ this.lg_listroom1.dialog_invite_copy_link }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="inviteMembers">
            <v-icon dark right> mdi-send </v-icon>
            {{ this.lg_listroom1.dialog_invite_send_link }}
          </v-btn>
        </v-card-actions> -->
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogclosemeeting" width="unset">
      <v-card>
        <v-card-title class="text-h5">
          {{ this.lg_listroom1.dialog_delete }}</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="canceldialogCloseMeetion"
            >{{ this.lg_listroom1.cancel }}</v-btn
          >
          <v-btn color="red darken-1" text @click="confirmdialogCloseMeetion"
            >{{ this.lg_listroom1.delete }}</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- width="unset" -->
    <v-dialog v-model="moreinfodialog" scrollable  min-width="350" max-width="500">
      <v-card elevation="2" class="v-card-style">
        <v-card-title class="d-flex align-center">
  <!-- ซ้าย -->
  <h3 style="color: #000000;">
    {{lg_listroom1.more_info}}
  </h3>
  <v-spacer></v-spacer>
  <!-- ขวา -->
  <v-btn icon @click="moreinfodialog = false" height="20">
    <v-icon>mdi-close</v-icon>
  </v-btn>
</v-card-title>

        <v-divider></v-divider>
       <v-card-text  align="left">
        </v-card-text>
            <v-list dense class="mt-n4">
                  <v-list-item>
                  <v-list-item-content style="max-width: 120px;font-size:16px;">{{
                    lg_listroom1.room_name
                  }}</v-list-item-content>
                  <v-list-item-content class="align-end" style="font-size:16px;">
                    {{ moreinfodialogdata.meet_topic }}
                  </v-list-item-content>
                </v-list-item>
                <!-- <v-list-item>
                  <v-list-item-content style="max-width: 120px;font-size:16px;">{{
                    lg_listroom1.room_id
                  }}</v-list-item-content>
                  <v-list-item-content class="align-end" style="font-size:16px;">
                    {{ moreinfodialogdata.meet_name }}
                  </v-list-item-content>
                </v-list-item> -->

                <v-list-item>
                  <v-list-item-content style="max-width: 120px;font-size:16px;">{{
                    lg_listroom1.room_user
                  }}</v-list-item-content>
                  <v-list-item-content class="align-end" style="font-size:16px;">
                    {{ moreinfodialogdata.tbl_account?moreinfodialogdata.tbl_account.acc_fullname:"" }}
                  </v-list-item-content>
                </v-list-item>

                <!-- <v-list-item>
                  <v-list-item-content style="max-width: 120px;font-size:16px;">{{
                    lg_listroom1.room_company
                  }}</v-list-item-content>
                  <v-list-item-content class="align-end" style="font-size:16px;">
                    {{ moreinfodialogdata.company_name }}
                  </v-list-item-content>
                </v-list-item> -->

                <!-- <v-list-item>
                  <v-list-item-content style="max-width: 120px;font-size:16px;">{{
                    lg_listroom1.room_department
                  }}</v-list-item-content>
                  <v-list-item-content class="align-end" style="font-size:16px;">
                    {{ moreinfodialogdata.department_name }}
                  </v-list-item-content>
                </v-list-item> -->

                <v-list-item>
                  <v-list-item-content style="max-width: 120px;font-size:16px;">{{
                    lg_listroom1.room_date
                  }}</v-list-item-content>
                  <v-list-item-content class="align-end" style="font-size:16px;">
                    {{ formatDate(moreinfodialogdata.meet_create) }}
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content style="max-width: 120px;font-size:16px;">{{
                    lg_listroom1.room_schedule
                  }}</v-list-item-content>
                  <!-- green--text -->
                  <v-list-item-content class="align-end " style="font-size:16px;">
                    {{ formatDate(moreinfodialogdata.meet_start) }}
                  </v-list-item-content>
                </v-list-item>


                <v-list-item
                 :class="{ 'd-none': moreinfodialogdata.meet_verify_login === null || moreinfodialogdata.meet_verify_login === 'N' }"
                
                >
                  <v-list-item-content style="max-width: 120px;font-size:16px;">{{
                    lg_listroom1.room_remark
                  }}</v-list-item-content>
                  <v-list-item-content
                
                  >
                    <v-list-item-content class="align-end red--text" style="font-size:16px;">{{
                      lg_listroom1.require_sub_login2
                    }}</v-list-item-content>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                :class="{ 'd-none': moreinfodialogdata.meet_verify_sta === null || moreinfodialogdata.meet_verify_sta === 'N' }"
              
                >
                  <v-list-item-content style="max-width: 120px;font-size:16px;">{{
                    lg_listroom1.room_remark
                  }}</v-list-item-content>
                  <v-list-item-content
                  >
                    <v-list-item-content class="align-end red--text" style="font-size:16px;">{{
                      lg_listroom1.enter_sub_email
                    }}</v-list-item-content>
                  </v-list-item-content>
                </v-list-item>


                <v-list-item
                :class="{ 'd-none': moreinfodialogdata.meet_pass === null || moreinfodialogdata.meet_pass === '' }"
                class="mt-n4"
                
                >
                  <v-list-item-content style="max-width: 110px;font-size:16px;">{{
                    lg_listroom1.password
                  }}</v-list-item-content>
                  <v-list-item-content
                  >
                    <v-list-item-content class="align-end red--text" style="font-size:16px;">
                      <!-- {{
                      item.meet_pass
                    }} -->
                      <v-text-field
                        class="align-end red--text ml-n1"
                        single-line
                        readonly
                        flat 
                        hide-details
                        v-model="moreinfodialogdata.meet_pass"
                        :append-icon="
                          moreinfodialogdata.showpass ? 'visibility' : 'visibility_off'
                        "
                        @click:append="moreinfodialogdata.showpass = !moreinfodialogdata.showpass"
                        :type="moreinfodialogdata.showpass ? 'password' : 'text'"
                        required
                        variant
                        solo
                        dense
                      />
                    </v-list-item-content>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                class="mt-n2"
                 :class="{ 'd-none': moreinfodialogdata.meet_record_on_start_sta === 'N' }"
              
                >
                  <v-list-item-content style="max-width: 120px;font-size:16px;">{{
                    lg_listroom1.room_record
                  }}</v-list-item-content>
                  <v-list-item-content
                  >
                    <v-list-item-content class="align-end red--text" style="font-size:16px;">{{
                      lg_listroom1.room_record_detail
                    }}</v-list-item-content>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                :class="{ 'd-none': moreinfodialogdata.meet_lobby_sta === 'N' }"
              
                >
                  <v-list-item-content style="max-width: 120px;font-size:16px;">{{
                    lg_listroom1.room_lobby
                  }}</v-list-item-content>
                  <v-list-item-content
                 
                  >
                    <v-list-item-content class="align-end red--text" style="font-size:16px;">{{
                      lg_listroom1.meet_sub__option_lobby
                    }}</v-list-item-content>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogcreateroom"  width="unset">
          <v-card outlined tile v-bind:style="{ padding: '0.5rem 2rem 2rem' }">
            <!-- <v-card-title>
          <v-spacer></v-spacer> -->
          <!-- <v-btn
  color="#205295"
  @click="dialogcreateroom = false"
  height="20"
  width="20"
  fab
  small
>
  <v-icon color="white">mdi-close</v-icon>
</v-btn> -->
        <!-- </v-card-title> -->
        <!-- <v-divider></v-divider> -->
            <!-- formCreateMeetroom -->
            <!-- <br /> -->
            <!-- <h3 class="text-center">
              <v-icon color="info">mdi-shield-account</v-icon>
              {{ this.lg_create_meetroom.title }}
            </h3> -->
            <br />
            <form @submit.prevent="onSubmit">
              <div class="home-page">
                <!-- <img src="/logo.png" alt="" class="app-logo" />
        <br /> -->
  
               
                  <!-- <v-tabs fixed-tabs background-color="#205295" dark>
                    <v-tabs-slider color="#FFE9B1"></v-tabs-slider>
                    <v-tab
                      :color="createMode === 'now' ? 'primary' : 'default'"
                      @click="createMode = 'now'"
                    >
                      {{ lg_create_meetroom.create_room_now }}
                    </v-tab>
                  </v-tabs> -->
                   <v-row class="justify-left mb-5">
                    <!--  v-bind:style="{ color: '#205295' }" -->
                  <h2 class="">{{ lg_create_meetroom.create_room_now }}</h2>  
                   </v-row>
                   <v-divider></v-divider>
  
                <div class="create-room-form">
                   <!-- <v-row >
    <v-col cols="12" xl="7" lg="7" md="7" sm="7" xs="12"  class="mt-0">
                 <p class="section-desc">{{lg_create_meetroom.meet_topic}}</p> 
                  <v-text-field
                    v-bind:style="{ width: '100%' }"
                    :placeholder="lg_create_meetroom.meet_topic"
                    outlined
                    dense
                    v-model="topic"
                    autocomplete="off"
                    hide-details
                  ></v-text-field>
                  <div style="width: 100%" v-if="createMode === 'schedule'">
                    <v-menu
                      ref="dateMenu"
                      v-model="dateMenu"
                      :close-on-content-click="false"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="formatDate"
                          clearable
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          :placeholder="lg_create_meetroom.meet_date_start"
                          style="width: 100%"
                          class="white-input"
                          required
                          hide-details
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="date"
                        no-title
                        scrollable
                        locale="th-TH"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="dateMenu = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.dateMenu.save(date)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                    <v-menu
                      ref="timeMenu"
                      v-model="timeMenu"
                      :close-on-content-click="false"
                      :return-value.sync="time"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                      required
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="time"
                          clearable
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          :placeholder="lg_create_meetroom.meet_time_start"
                          style="width: 100%"
                          class="white-input"
                          hide-details
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-model="time"
                        scrollable
                        locale="th-TH"
                        format="24hr"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="dateMenu = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.timeMenu.save(time)"
                        >
                          OK
                        </v-btn>
                      </v-time-picker>
                    </v-menu>
                  </div>
                  </v-col>
                  </v-row> -->
                  <!-- <v-text-field
                    style="width: 100%"
                    :placeholder="lg_create_meetroom.meet_password"
                    outlined
                    v-model="password"
                    class="white-input"
                    autocomplete="new-password"
                    type="password"
                    :loading="loading"
                  ></v-text-field> -->
               <v-card class="bordercardoption" elevation="0" >
                <!-- <h2 class="pt-2" v-bind:style="{ margin: '1rem 2rem 0' }">
                  {{ this.lg_create_meetroom.meet_option }}
                </h2> -->
             <v-card-text >

    <v-row >
    <v-col cols="12"  class="">
                 <p class="black--text section-desc ma-0">{{lg_create_meetroom.meet_topic}}</p> 
                 </v-col>
                  </v-row>

                  <v-row  class="mt-n6">
                 <v-col cols="12"  class="">
                  <v-text-field
                  class="custom-input"
                    v-bind:style="{ width: '100%' }"
                    :placeholder="lg_create_meetroom.enter_meet_topic"
                    outlined
                    dense
                    v-model="topic"
                    autocomplete="off"
                    hide-details
                  ></v-text-field>
               </v-col>
                  </v-row>
                      <v-row >
    <v-col cols="12"  class="">
                 <p class="black--text section-desc ma-0">{{lg_create_meetroom.create_meet_date}}</p> 
                 </v-col>
                  </v-row>


  <v-row  class="mt-n5">
    <v-col cols="12"  class="">
       <datetime
                      class="border-dt-picker minheighttime"
                      type="datetime"
                      input-id="menutimeadd"
                      value-zone="Asia/Bangkok"
                      :placeholder="lg_create_meetroom.select_meeting_date_and_time"
                      v-model="datetime_meet_start"
                      @input="getWorkHourDuration()"
                    />
      
              </v-col>
              <!-- <v-col cols="12" xl="7" lg="7" md="7" sm="7" xs="12" class="">
          </v-col> -->
          </v-row>
  
              <v-row >
                <!-- xl="3" lg="3" md="3" sm="3" xs="12" -->
    <v-col cols="12"  class="mt-n3">
      <v-switch  class=" checkbox-options"
                    v-model="cbPassword"
                    hide-details
                  > 
                  <template v-slot:label>
                    <!-- :style="{ fontSize: $vuetify.breakpoint.xsOnly ? '16px' : '16px' }" -->
              <span  class="black--text section-desc">{{ lg_create_meetroom.passcode }}</span>
            </template>
                </v-switch>
              </v-col>
              <!-- xl="9" lg="9" md="9" sm="9" xs="12" -->
              <v-col cols="12" class="mt-n3">
                  <!-- <template v-slot:label> -->
                    <!--  :placeholder="lg_create_meetroom.meet_password"  type="password" -->
                      <!-- :label="lg_create_meetroom.passcode" -->
                    <v-text-field
                    :disabled="!cbPassword"
                    width="100"
                    outlined
                    v-model="password"
                    class="white-input custom-input"
                    autocomplete="new-password"
                    :loading="loading"
                    hide-details
                    dense
                  ></v-text-field>
    <!-- </template> -->
  </v-col>
  </v-row>
                
  <v-row class="ml-4 mt-n4  grey--text">
    <v-col cols="12" >
      {{ lg_create_meetroom.passcode_subtitle }}
  </v-col>
  </v-row>

  <v-divider class="my-4 dashed-divider"></v-divider>

  <div v-if="acc_plan !== 'FREE'">
  <v-row >
    <!-- xl="6" lg="6" md="6" sm="6" xs="12" -->
    <v-col cols="12"  class="mt-n3">
      <v-switch class="checkbox-options"
                    v-model="cbVerify"
                    hide-details
                  > 
               <template v-slot:label>
                <!-- :style="{ fontSize: $vuetify.breakpoint.xsOnly ? '16px' : '16px' }" -->
              <span  class="black--text section-desc">{{ lg_create_meetroom.requireauthenticationtojoin }}</span>
            </template>
                </v-switch>
              </v-col>
              <!-- xl="6" lg="6" md="6" sm="6" xs="12" -->
              <v-col cols="12" class="mt-n3">
                <!-- :label="lg_create_meetroom.requireauthenticationtojoin" -->
                    <v-select
                    class="custom-input"
                  :disabled="!cbVerify"
                  :items="requestauthentojoindatalist"
                  item-text="text"
                  item-value="value"
                  v-model="requestauthentojoin"
                  outlined
                  hide-details
                  dense
                  @click:clear="requestauthentojoin = null"
                  clearable
                ></v-select>
  </v-col>
  </v-row>

  <v-divider class="mb-4 mt-8 dashed-divider"></v-divider>

  <v-row>
    <v-col cols="12">
      <v-switch class="checkbox-options"
                    v-model="cbRecordonStart"
                    hide-details
                  > 
                    <template v-slot:label>
                      <!-- :style="{ fontSize: $vuetify.breakpoint.xsOnly ? '16px' : '16px' }" -->
              <span  class="black--text section-desc">{{ lg_create_meetroom.meet_option_record_on_start }}</span>
            </template>
  </v-switch>
  </v-col>
  </v-row>
  
                
  <v-row class="ml-4 mt-n6  grey--text">
    <v-col cols="12" >
    {{ lg_create_meetroom.meet_option_sub_record_on_start }}
  </v-col>
  </v-row>

  <v-divider class="my-4 dashed-divider"></v-divider>

  <v-row>
    <v-col cols="12">
      <v-switch class="checkbox-options"
                    v-model="cbLobby"
                    hide-details
                  > 
              <template v-slot:label>
                <!-- :style="{ fontSize: $vuetify.breakpoint.xsOnly ? '16px' : '16px' }" -->
              <span  class="black--text section-desc">{{ lg_create_meetroom.meet_option_lobby }}</span>
            </template>
  </v-switch>
  </v-col>
  </v-row>
  
                
  <v-row class="ml-4 mt-n6  grey--text">
    <v-col cols="12" >
    {{ lg_create_meetroom.meet_sub__option_lobby }}
  </v-col>
  </v-row>

  </div>

                  <!-- <v-switch class="checkbox-options"
                    v-model="selected"
                    :label="lg_create_meetroom.meet_option_share_screen"
                    value=""
                  ></v-switch> -->
                   </v-card-text>
                         </v-card>
   <v-card-actions :class="{ 'justify-end': !$vuetify.breakpoint.xsOnly,'justify-center': $vuetify.breakpoint.xsOnly}">
          <!-- <v-spacer></v-spacer> -->
          <v-btn color="red darken-1" text @click="dialogcreateroom = false" class="mr-8">
          <h4>{{lg_create_meetroom.btn_cancel}} </h4> 
          </v-btn>
          <!-- <v-row class="justify-center mb-5  mt-5 "> -->
              <v-btn :height="$vuetify.breakpoint.xsOnly?35:null" type="submit" v-bind:style="{ backgroundColor: '#205295', color: '#ffffff' }">
                {{
                    lg_create_meetroom.meet_create
                  }}
              </v-btn>
            <!-- </v-row> -->
        </v-card-actions>

            
                </div>
              </div>
              <LoadingDialog v-if="resultVisible"></LoadingDialog>
              <ZoomCreateRoomSuccessDialog
                :visible="resultVisible"
                :result="result"
                @close="
                  () => {
                    resultVisible = false;
                    loadListRoomMeetingData();
                  }
                "
              />
         
            </form>
          </v-card>
    </v-dialog>

    <v-dialog
  v-model="dialogdeactivate"
  max-width="500"
  persistent
>
  <v-card
    class="pa-6 text-center"
    style="border-radius: 24px;"
  >
    <!-- Title -->
    <div class="text-h6 font-weight-bold mb-3">
    Your account is currently deactivated. Would you like to reactivate it?
    </div>

    <v-row justify="center" no-gutters>
      <v-btn
        text
        color="green"
        class="mr-6"
       @click="ReactivateData()"
      >
        Reactivate
      </v-btn>

      <v-btn
        text
        color="black"
         @click="Logout()"
      >
        Logout
      </v-btn>
    </v-row>

  </v-card>
</v-dialog>
  </v-container>
</template>

<script>
import api from "@/services/api";
import LoadingDialog from "@/components/cards/LoadingDialog.vue";
import { server } from "../services/constants";
import { format } from "date-fns";

import { feature } from "../services/constants";
import { lg_listroom1 } from "./language/lg_listroom_1";
import { lg_create_meetroom } from "./language/lg_create_meet_room";
import ZoomCreateRoomSuccessDialog from "@/components/cards/ZoomCreateRoomResultDialog.vue";
import { parsejwt } from "@/views/jsfunction/parseJwtData";

export default {
  name: "listroom",
  beforeCreate() {
    if (api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login-account");
    }
    localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_listroom1 = lg_listroom1.listroom1_th)
      : (this.lg_listroom1 = lg_listroom1.listroom1_en);

       localStorage.getItem(feature.LANGUAGE) === "th"
        ? (this.lg_create_meetroom = lg_create_meetroom.create_meetroom_th)
        : (this.lg_create_meetroom = lg_create_meetroom.create_meetroom_en);
  },
  async mounted() {
  //   let ts = 1759822264;
  //    if (ts.toString().length === 10) ts = ts * 1000;
  // const date = new Date(ts + 7 * 60 * 60 * 1000);
  //   alert(date.toISOString().slice(0, 19).replace("T", " "));
    const user_id = localStorage.getItem(server.USER_ID);
    const user_data = await api.getAccountById(user_id);
    this.account = user_data.data;
    
    if(user_data.data.status == "I"){
      this.dialogdeactivate = true;
      // return;
    }

    this.acc_plan = parsejwt(localStorage.getItem(server.TOKEN_KEY)).acc_plan;
    localStorage.setItem(server.MEET_STA, "false");
    if (localStorage.getItem(server.ROLE) == "Admin") {
      this.checkRoleAdmin = true;
    }
    const userId = localStorage.getItem(server.USER_ID);
    if (!userId || !api.isLoggedIn()) {
      this.$router.push("/");
    }
    this.requestauthentojoindatalist=[{value:0,text:this.lg_create_meetroom.OTPverification},{value:1,text:this.lg_create_meetroom.LogintoDmeets}];
    // this.$store.state.loadMenu = true;
    this.$store.state.meetSta = false;
    this.$store.state.loadFooter = false;
    // this.$store.state.navMenu = true;
    this.loadListRoomMeetingData();
  },
  components: {
    LoadingDialog,
    ZoomCreateRoomSuccessDialog,
  },
  // new Date().toISOString(),
  data() {
    return {  
      account:null,
      dialogdeactivate:false,
      datetime_meet_start:null,
      requestauthentojoin:null,
      requestauthentojoindatalist:[],
      reload_page: false,
      mDataArray: [],
      mDataPackageArray: [],
      privacy_sta: "false",
      privacyDlg: false,
      loading: false,
      resultVisible: false,
      createMode: "now",
      acc_plan: "",
      appId: "",
      apiKey: "",
      password: null,
      dateMenu: false,
      timeMenu: false,
      date: null,
      time: null,
      result: null,
      topic: null,
      resultJson: "",
      resultJsonCompanyName: null,
      username: "",
      cbPassword: false,
      cbRecordonStart: false,
      cbLobby: false,
      cbVerify: false,
      dialogcreateroom:false,
      moreinfodialog:false,
      moreinfodialogdata:{},
      acc_plan: "",
      e1: true,
      dataclosemeeting: null,
      dialogclosemeeting: false,
      message: null,
      messagelivestream: null,
      checkRoleAdmin: false,
      resultJson: "",
      itemsPerPageArray: [3, 6],
      search: "",
      alertDlg: false,
      titleMessageAlert: this.lg_listroom1.titleMessageAlert,
      messageAlert: this.lg_listroom1.messageAlert,
      role: "",
      filter: {},
      sortDesc: true,
      page: 1,
      itemsPerPage: 3,
      mDataArray: [],
      sortBy: "id",
      keys: ["meet_name"],
      meetjoin: {
        meet_id: 0,
        meet_join_name: "",
        account_id: 0,
      },
      selected: null,
      meet: {
        meet_id_show: "",
        meet_name: "",
        meet_appid: "vpaas-magic-cookie-e205800afeca4002aad705d1994953cb",
        meet_apikey: "vpaas-magic-cookie-e205800afeca4002aad705d1994953cb/560000",
        meet_token: "",
        meet_sta: "Y",
        account_id: 0,
        company_id: 0,
        company_name: "",
        department_id: 0,
        department_name: "",
        meet_create: null,
        meet_end: null,
        meet_admin_link: "",
        meet_user_link: "",
        meet_pass: "",
        meet_topic: "",
        meet_start: null,
        meet_lobby_sta: "N",
        meet_verify_sta: "N",
        meet_verify_login:"N",
        meet_room_license: "FREE",
      },
      dialog: false,
      emails: [],
      selectedRoom: null,
    };
  },
  // watch: {
  //   moreinfodialogdata(newVal, oldVal) {
  //     console.log('Active changed from', oldVal, 'to', newVal);
  //     oldVal = newVal;
    
  //     // Do something when 'active' changes
  //   }
  // },
  computed: {
    numberOfPages() {
      return Math.ceil(this.mDataArray.length / this.itemsPerPage);
    },
    filteredKeys() {
      return this.keys.filter((key) => key !== "meet_name");
    },
  },
  methods: {
    async ReactivateData(){
        const result_update_account = await api.updateAccount(
        this.account.id,
        {status:"A",date_deactivate:null,deactivate_description:null}
      );
         if(result_update_account.status == 401){
      this.$store.state.loadMenu = false;
       this.$store.dispatch("doLogout");
        return;
      }

      if (result_update_account.status == 200 || result_update_account.status == 201) {
      this.dialogdeactivate = false;
      }

    },
     async Logout(){
      this.$store.dispatch("doLogout");
      this.dialogdeactivate = false;
      return;

    },
    async onSubmit() {
        if((this.topic == "" || this.topic == null)){
          this.$swal.fire(this.lg_create_meetroom.titlemeeterror, this.lg_create_meetroom.checkmeet_topic, "error");
          return;
        }
                if((this.datetime_meet_start == "" || this.datetime_meet_start == null)){
          this.$swal.fire(this.lg_create_meetroom.titlemeeterror, this.lg_create_meetroom.checkmeet_dateandtime, "error");
          return;
        }
      
          if((this.cbPassword && (this.password == null || this.password == "")) || ((this.password != null && this.password != "") && !this.cbPassword)){
          this.$swal.fire(this.lg_create_meetroom.titlemeeterror, this.lg_create_meetroom.checkpasscode, "error");
          return;
        }

        if((this.cbVerify && (this.requestauthentojoin == null)) || ((this.requestauthentojoin !== null) && !this.cbVerify)){
          this.$swal.fire(this.lg_create_meetroom.titlemeeterror, this.lg_create_meetroom.checkrequireauthenticationtojoin, "error");
          return;

        }

        const { createMode, password, date, time, topic } = this;
        const userId = localStorage.getItem(server.USER_ID);
        try {
          let body = { password, host: window.location.origin, topic, userId };
          if (createMode === "schedule") {
            if (!date || !time) {
              throw new Error("กรุณากรอกวันและเวลาเริ่ม");
            }
            const dateOnly = format(parseISO(date), "yyyy-MM-dd");
            const startDate = parse(
              `${dateOnly} ${time}`,
              "yyyy-MM-dd HH:mm",
              new Date()
            );
            body = {
              ...body,
              startDate,
            };
          }
  
          this.$swal.showLoading();
  
          // const res = await axios.post("/rooms", body);
  
          // localStorage.setItem(server.MEET_STA, "true");
          // console.log(body)
        //   const res = await api.meetRoom(body);
        const res = await api.createMeeting100ms(body);

          
        //   return;
          if (res && res.data && res.data.status === "error") {
            this.$swal.fire(
              res.data.title || "Error",
              res.data.message || "Try again",
              "error"
            );
            return;
          }
          localStorage.setItem(server.MEET_STA, "false");
  
          // {"id":"2221240092272505",
          // "roomName":"2221 2400 9227 2505",
          // "password":null,
          // "startDate":null,
          // "topic":"44444",
          // "updatedAt":"2021-07-15T09:29:49.931Z",
          // "createdAt":"2021-07-15T09:29:49.931Z",
          // "modLink":"http://localhost:8080/meet/vpaas-magic-cookie-0d676e1889ea4299a153f25b1d1ee9f4/2221240092272505?moderator=true",
          // "userLink":"http://localhost:8080/meet/vpaas-magic-cookie-0d676e1889ea4299a153f25b1d1ee9f4/2221240092272505"}
  
          // console.log(JSON.stringify(res.data));
          // if (this.createMode == "schedule") {
          //   alert("schedule");
          // alert(JSON.stringify(res.data));
          this.$store.state.loadMenu = true;
          this.username = localStorage.getItem(server.USERNAME);
          this.resultJson = await api.checkRegister(this.username);
  
          // this.resultJsonCompanyName = await api.getCompanyByID(
          //   this.resultJson.data.company_id
          // );
          // this.meet.meet_token = token;
          this.meet.meet_id_show = res.data.roomName;
          this.meet.meet_name = res.data.id;
          this.meet.meet_appid = res.data.meet_appid;
          this.meet.meet_apikey = res.data.meet_appid;
          this.meet.meet_admin_link = `${window.location.origin}/meet/${res.data.id}`;
          this.meet.meet_user_link = `${window.location.origin}/meet/${res.data.id}`;
        //   this.meet.meet_admin_link = res.data.modLink;
        //   this.meet.meet_user_link = res.data.userLink;
          this.meet.meet_pass = this.password;
          this.meet.meet_topic = res.data.topic;
          // if (this.createMode == "schedule") {
          //   this.meet.meet_start = new Date();
          // } else {
          //   this.meet.meet_start = this.currentDateTime();
          // }
          this.meet.meet_start = `${this.datetime_meet_start.split("T")[0]} ${this.datetime_meet_start.split("T")[1].substring(0,5)}`;

          if (this.cbRecordonStart == true) {
            // alert("schedule");
            this.meet.meet_record_on_start_sta = "Y";
          } else {
            this.meet.meet_record_on_start_sta = "N";
          }
  
          if (this.cbLobby == true) {
            // alert("schedule");
            this.meet.meet_lobby_sta = "Y";
          } else {
            this.meet.meet_lobby_sta = "N";
          }
  
          // if (this.cbVerify == true) {
          //   this.meet.meet_verify_sta = "Y";
          // } else {
          //   this.meet.meet_verify_sta = "N";
          // }

          if(this.cbVerify && this.requestauthentojoin !== null){
            if(this.requestauthentojoin == 0){
              this.meet.meet_verify_sta = "Y";
              this.meet.meet_verify_login = "N";
              
            }else if(this.requestauthentojoin == 1){
              this.meet.meet_verify_sta = "N";
              this.meet.meet_verify_login = "Y";
            }else{
              this.meet.meet_verify_sta = "N";
              this.meet.meet_verify_login = "N";
            }

          }else{
            this.meet.meet_verify_sta = "N";
            this.meet.meet_verify_login = "N";
          }
  
          // alert(this.meet.meet_start);
  
          //   this.meet.meet_appid = this.appId;
          //   this.meet.meet_apikey = this.appId;
          this.meet.account_id = this.resultJson.data.id;
          this.meet.company_id = this.resultJson.data.company_id;
          // this.meet.company_name = this.resultJsonCompanyName.data.company_name;
          this.meet.company_name = localStorage.getItem(server.COMPANY_NAME);
          this.meet.department_id = localStorage.getItem(server.DEPARTMENT_ID);
          this.meet.department_name = localStorage.getItem(
            server.DEPARTMENT_NAME
          );
  
          // alert(this.meet.department_id);
          // alert(this.meet.department_name);
          this.meet.meet_create = this.currentDateTime();
          this.meet.meet_end = this.currentDateTime();
  
          if (localStorage.getItem(server.ROLE) == "Admin") {
            this.meet.meet_room_license = "PREMIUM";
          } else {
            this.meet.meet_room_license = localStorage.getItem(server.TOKEN_KEY)?parsejwt(localStorage.getItem(server.TOKEN_KEY)).acc_plan?parsejwt(localStorage.getItem(server.TOKEN_KEY)).acc_plan:"FREE":"FREE";
                        // this.meet.meet_room_license = localStorage.getItem(
            //   server.ACC_PLAN_STA
            // );
          }
  
          // alert(this.meet.meet_room_license);
        //   await api.addMeet(this.meet);
         await api.addMeet100ms(this.meet);
        
  
          this.meetjoin.meet_join_name = this.resultJson.data.acc_fullname;
          this.meetjoin.account_id = this.resultJson.data.id;
  
          this.resultJson = await api.checkByNameMeet100ms(
            this.meet.meet_name,
            this.meet.account_id
          );
          this.meetjoin.meet_id = this.resultJson.data.id;
  
          await api.addMeetJoin(this.meetjoin);
          this.$store.state.navMenu = false;
          this.$store.state.loadMenu = false;
          // }
          // this.result = {
          //   ...res.data,
          //   meet_user_link_meeting:this.meet.meet_user_link+"/meeting",
          //   ...this.meet,
          //   password,
          // };
            this.result = {
            ...res.data,
            meet_user_link_meeting:this.meet.meet_user_link,
            ...this.meet,
            password,
          };
          
          this.resultVisible = true;
          this.loading = true;
          this.date = null;
          this.time = null;
          this.topic = null;
          this.datetime_meet_start = null;
          this.password = null;
          this.dialogcreateroom = false;
          this.$swal.close();
  
          this.loading = false;
        } catch (error) {
          this.$store.state.loadMenu = false;
          this.$swal.close();
          this.loading = false;
          // this.$swal.fire("Error", error.message, "error");
          this.$swal.fire("Error",this.lg_create_meetroom.enter_meeting_details, "error");
          console.log(error);
        }
      },
    async Clickdialogcreate(){
      this.dialogcreateroom = true;
      
    },
   async moreinfodialogfn(item){
      this.moreinfodialogdata = {};
      this.moreinfodialogdata = item;
this.moreinfodialog = true;
    },
    onCopy() {
      this.dialog = false;
      this.$swal.fire("Success", "Copied", "success");
    },
    onError() {
      this.$swal.fire("Error", "Can Not Copy", "error");
    },
    openInviteModal(item) {
      this.selectedRoom = item;
      this.assignMessage(item);
      this.dialog = true;
    },
    assignMessage(item) {
      // old format date format(new Date(item.meet_start), "MMM dd, yyyy HH:mm")
      this.message =
        `${item.tbl_account.acc_fullname} is inviting you to a scheduled Dmeets meeting.\n\n` +
        `Topic: ${item.meet_topic ?? "-"}\n` +
        `${
          item.meet_start
            ? `Time: ${
                new Date(item.meet_start).toLocaleString("en-US", {
                  timeZone: "Asia/Bangkok",
                  dateStyle: "medium",
                  timeStyle: "short",
                }) + " Bangkok Time (UTC/GMT+7)"
              }\n\n`
            : ""
        }` +
        "Join Dmeets Meeting\n" +
        item.meet_user_link +
        // "/meeting" +
        "\n\n" +
        "Meeting Number : \n" +
        item.meet_name +
        "\n" +
        `${item.meet_pass ? `Password:\n${item.meet_pass}\n` : ""}`;

      this.messagelivestream =
        `${item.tbl_account.acc_fullname} is inviting you to a scheduled Dmeets meeting.\n\n` +
        `Topic: ${item.meet_topic ?? "-"}\n` +
        `${
          item.meet_start
            ? `Time: ${
                new Date(item.meet_start).toLocaleString("en-US", {
                  timeZone: "Asia/Bangkok",
                  dateStyle: "medium",
                  timeStyle: "short",
                }) + " Bangkok Time (UTC/GMT+7)"
              }\n\n`
            : ""
        }` +
        "Join Dmeets Livestream\n" +
        item.meet_user_link +
        "/livestream" +
        "\n\n" +
        "Meeting Number : \n" +
        item.meet_name +
        "\n" +
        `${item.meet_pass ? `Password:\n${item.meet_pass}\n` : ""}`;
    },
    removeEmail(item) {
      this.emails.splice(this.emails.indexOf(item), 1);
      this.emails = [...this.emails];
    },
    async inviteMembers() {
      this.assignMessage(this.selectedRoom);
      let setlink = `${this.selectedRoom.tbl_account.acc_fullname} has invited you to join a meeting via Dmeets, a secure and PDPA-compliant online meeting platform.\n\n` +
        `Meeting Title: ${this.selectedRoom.meet_topic ?? "-"}\n` +
        `${
          this.selectedRoom.meet_start
            ? `Date & Time: ${
                new Date(this.selectedRoom.meet_start).toLocaleString("en-US", {
                  timeZone: "Asia/Bangkok",
                  dateStyle: "medium",
                  timeStyle: "short",
                }) + " Bangkok Time (UTC/GMT+7)"
              }\n\n`
            : ""
        }` +
        "Join Link: " +
        this.selectedRoom.meet_user_link +
        // "/meeting" +
        "\n" +
        `${this.selectedRoom.meet_pass ? `Password: ${this.selectedRoom.meet_pass}\n\n` : `\n\n`}`+
        `No installation needed — just click the link to join from your browser or mobile.\n\n`+
        `This is an automated email from Dmeets. Please do not reply to this message.\n`+
        `If you have questions about the meeting, please contact the organizer directly.\n\n`+
        `Best regards,\n`+
        `Dmeets Team\n`+
        `https://dmeets.dcm.co.th\n`;
      try {
        this.$swal.showLoading();
        const payload = {
          members: this.emails,
          link: setlink,
          subject:`${this.selectedRoom.tbl_account.acc_fullname} invited you to a Dmeets meeting`,
        };
        const res = await api.inviteMembers(payload);
        if (res && res.data && res.data.status === "success") {
          this.dialog = false;
   this.$swal.fire({
  title:`<span style="color:black;">${this.lg_listroom1.invitation_sent}</span>`,
  html:`<span style="color:black;">${this.lg_listroom1.invitation_sent_details}</span>`,
  showDenyButton: false, 
  showCancelButton: false, 
  confirmButtonText: `${this.lg_listroom1.close}`,
  denyButtonText: `${this.lg_listroom1.close}`,
  confirmButtonColor: '#205295',
  denyButtonColor: '#000000',
  allowOutsideClick: true, 
  allowEscapeKey: true,  
  allowEnterKey: true   
}).then((result) => {
  if (result.isConfirmed) {
  } else if (result.isDenied) {
  }
});
        } else {
          this.$swal.fire("Error", res.data.message, "error");
        }
      } catch (e) {
        console.log(e);
        this.$swal.fire("Error", e.message, "error");
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      const [hh, mm] = day.split("T")[1].split(":");
      const hour = parseInt(hh);
      return `${year}-${month}-${day.split("T")[0]} ${hour + 7}:${mm}`;
    },
    async loadListRoomMeetingData() {
      this.mDataArray = [];

      let role = localStorage.getItem(server.ROLE);
      let company_id = localStorage.getItem(server.COMPANYID);
      let department_id = localStorage.getItem(server.DEPARTMENT_ID);
      let userId = localStorage.getItem(server.USER_ID);
      let result = null;

      if (role == "Admin") {
        result = await api.listRoomMeeting100ms();
      } else if (role == "Company Admin") {
        result = await api.listRoomMeetingByCompany100ms(company_id);
      } else {
        // result = await api.listRoomMeetingByDepartment100ms(department_id);
        result = await api.listRoomMeetingByAccountCreate100ms(userId);
      }

      //   console.log(result);
      // let count = result.data.count;
      // for (let i=0;i<count;i++){
      //     this.mDataArray.push(result.data.rows.[i]);
      // }
     
      if(result.status == 401){
       this.$store.dispatch("doLogout");
        return;
        // this.$router.push("/");
      }else{
  this.mDataArray = result.data.rows;
      }
    
      // console.log(this.mDataArray)
      // console.log(JSON.stringify(this.mDataArray));
      this.$store.state.loadMenu = false;
    },
    async dialogCloseMeetion(item) {
      this.dataclosemeeting = item;
      this.dialogclosemeeting = true;
    },
    async canceldialogCloseMeetion() {
      this.dataclosemeeting = null;
      this.dialogclosemeeting = false;
    },
    async confirmdialogCloseMeetion(item) {
      this.dialogclosemeeting = false;
      await this.onClickCloseMeetion(this.dataclosemeeting);
    },
    async onClickCloseMeetion(item) {
      this.username = localStorage.getItem(server.USERNAME);
      this.resultJson = await api.checkRegister(this.username);
      const userId = localStorage.getItem(server.USER_ID);
      this.meet.user_update = userId;
      this.meet.lastuser_update = new Date();
      this.role = localStorage.getItem(server.ROLE);
      if (this.role == "Admin") {
        // console.log("Admin");
        // alert("Admin Close Room");
        this.$store.state.loadMenu = true;
        // this.meet.meet_sta = "N";
        // await api.deleteMeet100ms(item.meet_id_show);
        await api.updateMeet100ms(item.meet_id_show,{meet_sta:'N'});
        this.loadListRoomMeetingData();
      } else {
        if (item.account_id == this.resultJson.data.id) {
          // alert("Account Close Room");
          this.$store.state.loadMenu = true;
          // this.meet.meet_sta = "N";
          // await api.deleteMeet100ms(item.meet_id_show);
          await api.updateMeet100ms(item.meet_id_show,{meet_sta:'N'});
          this.loadListRoomMeetingData();
        } else {
          this.titleMessageAlert = this.lg_listroom1.titleMessageAlert;
          this.messageAlert = this.lg_listroom1.messageAlert;
          this.alertDlg = true;
          return;
        }
      }
    },
    async onClickJoinMeetion(item) {
      this.$store.state.loadMenu = true;

      localStorage.setItem("jwt", item.meet_token);

      // console.log("token : " + item.meet_token);

      this.username = localStorage.getItem(server.USERNAME);
      this.resultJson = await api.checkRegister(this.username);

      this.meetjoin.meet_join_name = this.resultJson.data.acc_fullname;
      this.meetjoin.account_id = this.resultJson.data.id;
      this.meetjoin.meet_id = item.id;

      if (
        localStorage.getItem(server.USER_ID) == item.account_id ||
        localStorage.getItem(server.ROLE) == "Admin" ||
        localStorage.getItem(server.ROLE) == "Company Admin"
      ) {
        localStorage.setItem(server.MODERATOR_STA, "true");
      } else {
        localStorage.setItem(server.MODERATOR_STA, "false");
      }

      // console.log("token111 : ", localStorage.getItem(server.MODERATOR_STA));
      // console.log("token111 : ", localStorage.getItem(server.ROLE));
      // console.log("token111 : ", localStorage.getItem(server.USER_ID));

      // await api.addMeetJoin(this.meetjoin);

      // this.$store.state.meetSta = false;
      this.$store.state.navMenu = false;
      this.$store.state.loadMenu = false;

      // alert(item.id);
      // this.$router.push(`/meet/${item.meet_appid}/${item.meet_name}`);
      // this.$router.push(`/meet/${item.meet_name}/meeting`);
       this.$router.push(`/meet/${item.meet_name}`);
    },
    async onClickJoinLivestream(item) {
      this.$store.state.loadMenu = true;
      localStorage.setItem("jwt", item.meet_token);
      // console.log("token : " + item.meet_token);
      this.username = localStorage.getItem(server.USERNAME);
      this.resultJson = await api.checkRegister(this.username);
      this.meetjoin.meet_join_name = this.resultJson.data.acc_fullname;
      this.meetjoin.account_id = this.resultJson.data.id;
      this.meetjoin.meet_id = item.id;
      if (
        localStorage.getItem(server.USER_ID) == item.account_id ||
        localStorage.getItem(server.ROLE) == "Admin" ||
        localStorage.getItem(server.ROLE) == "Company Admin"
      ) {
        localStorage.setItem(server.MODERATOR_STA, "true");
      } else {
        localStorage.setItem(server.MODERATOR_STA, "false");
      }
      // console.log("token111 : ", localStorage.getItem(server.MODERATOR_STA));
      // console.log("token111 : ", localStorage.getItem(server.ROLE));
      // console.log("token111 : ", localStorage.getItem(server.USER_ID));
      await api.addMeetJoin(this.meetjoin);
      // this.$store.state.meetSta = !this.$store.state.meetSta;
      this.$store.state.navMenu = false;
      this.$store.state.loadMenu = false;
      // alert(item.id);
      // this.$router.push(`/meet/${item.meet_appid}/${item.meet_name}`);
      this.$router.push(`/meet/${item.meet_name}/livestream`);
    },
    async getWorkHourDuration() {
        // if (
        //   this.datetime_meet_start !== "" &&
        //   this.datetime_meet_start !== ""
        // ) {
          // console.log(this.datetime_meet_start)
          // this.meet.meet_start = `${datetime_meet_start.split("T")[0]} ${datetime_meet_start.split("T")[1].substring(0,5)}`;
        // }
      },
         getMaxTime() {
        const selected = moment.tz(this.datetime_meet_start, "Asia/Bangkok").format("YYYY-MM-DD");
        const today = moment.tz("Asia/Bangkok").format("YYYY-MM-DD");

        // if (selected === today) {
        //   return moment.tz("Asia/Bangkok").format("HH:mm");
        // }
        // return null;
      },
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },
    currentDateTime() {
        const current = new Date();
        const date =
          current.getFullYear() +
          "-" +
          (current.getMonth() + 1) +
          "-" +
          current.getDate();
        const time =
          current.getHours() +
          ":" +
          current.getMinutes() +
          ":" +
          current.getSeconds();
        const dateTime = date + " " + time;
  
        return dateTime;
      },
  },
};
</script>

<style scoped>
.text-tranform-none {
  text-transform: none;
}
.widthbtnjoinmobile200{
  width: 200px;
  align-self: center;
}
.widthbtnjoinipad200{
  width: 350px;
  align-self: center;
}
.border-dt-picker {
  border: 1px solid #d0d0d0;
  border-radius: 5px;
  height: 30px;
}

/* เพิ่ม: ให้ input ข้างในกว้าง 100% ด้วย */
.border-dt-picker >>> input {
  width: 100% !important;
}
.minheighttime {
  min-height: 40px;
  cursor: pointer;
  font-size: initial;
  padding-top: 7px;
  padding-left: 7px;
}
.v-card-style{
  border-radius: 8px;
}

.custom-input >>> .v-label {
  display: none;
}

.custom-input >>> fieldset {
  border-color: #d0d0d0;
  border-radius: 8px;
}

.custom-input >>> .v-input__slot {
  min-height: 40px;
}

.dashed-divider {
  border-top: 1px dashed #ccc !important;
}
 tbody {
     tr:hover {
        background-color: transparent !important;
     }
  }
</style>
